import { requestGet } from '../utils/requestApi'

export async function getSearchData(payload){
  return requestGet('search', payload)
}